import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import axios from 'axios';
import Swal from 'sweetalert2';
import TextField from '@mui/material/TextField';
import AutoComplete from '@mui/material/Autocomplete';
import {Box, ThemeProvider } from '@mui/material';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

const InternalReturn = (props) => {


  const [items, setItems] = useState([]);
  const [rows, setRows] = useState([{ did: '', id: '', product: '', batch: '', expiry: '', totqty: '', uamount: '',  }]);
  const [total, setTotal] = useState(0);
  const [subtotal, setSubTotal] = useState(0);

  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-');
  const nextQtyInputRef = useRef(null);

  const [pharmData,setpharmData]=useState({
        "sale_id":'',
        "sale_type":'',
        "pat":'',
        "patient":'',
        "cons":'',
        "product":'',
        "qty":'',
        "netamount":'',
        "total":'',
        "disc":'',
        "details":'',
        "paid":'',
        "balance":'',
        "mode":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
     });

  useEffect(() => {
    fetchPharmData();
  }, []);

  function fetchPharmData() {
    axios.get(`${baseUrl}indent-pharm-search/?dept=All`)
      .then((pharmResponse) => {
        setItems(pharmResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }


  const handleKeyDown = (e, index) => {
      const newRows = [...rows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
          if (e.target.name === 'product' || e.target.name === 'qty') {
                e.preventDefault();
                if (index === rows.length - 1) {
                  newRows.push({ did: '', id: '', product: '', batch: '', expiry: '', totqty: '', uamount: '' });
                }
              }
          break;
        // Handle arrow up key
        case 90:
          e.preventDefault();
            newRows.splice(index, 1);
          break;
        case 38:
          e.preventDefault();
          if (newRows[index].selectedItem === 0) {
            newRows[index].selectedItem = items.length - 1;
          } else {
            newRows[index].selectedItem--;
          }
          setRows(newRows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newRows[index].selectedItem === items.length - 1) {
            newRows[index].selectedItem = 0;
          } else {
            newRows[index].selectedItem++;
          }
          setRows(newRows);
          break;
        default:
          break;
      }
      setRows(newRows);
    };

 const handleSelect = (val, index, id) => {

  const selectedId = val;
  const selectedItem = val;


  if (!selectedItem) {
    console.log('Selected item not found');
    return;
  }
  const newRows = [...rows];


    const today = new Date(formattedDate);
    const expiry = new Date(selectedItem.product.expiry); // already YYYY-MM-DD

    // Calculate difference in days
    const diffTime = expiry.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays <= 0) {
    Swal.fire(`${diffDays} day(s) since expired`);
    return; // Prevent selection
  }

  // Check if the selected ID already exists in the rows
  const existingRowIndex = newRows.findIndex(row => row.id === selectedItem.id);

  if (existingRowIndex !== -1) {
    newRows[existingRowIndex].qty += 1;
    newRows[existingRowIndex].remainQty = newRows[existingRowIndex].totqty - newRows[existingRowIndex].qty;
    newRows[existingRowIndex].netamount = newRows[existingRowIndex].qty * newRows[existingRowIndex].uamount;
    if (newRows[existingRowIndex].remainQty < 0) {
      Swal.fire("Stock not available");
      newRows[existingRowIndex].remainQty = 0;
      newRows[existingRowIndex].qty = newRows[existingRowIndex].totqty;
      newRows[existingRowIndex].netamount = newRows[existingRowIndex].totqty * newRows[existingRowIndex].uamount;
    }
  } else {
    newRows[index] = {
      id: selectedItem.id,
      did: selectedItem.product.id,
      product: selectedItem.product.product,
      batch: selectedItem.product.batch,
      expiry: selectedItem.product.expiry,
      totqty: selectedItem.qty,
      uamount: selectedItem.product.uamount,
      qty: '',
      remainqty: selectedItem.product.qty - 1,
      netamount: selectedItem.product.uamount,
    };
  }

  setRows(newRows);

  if (diffDays < 15 ) {
    Swal.fire(`${diffDays} day(s) to expire  totqty = ${selectedItem.product.totqty}`);
  }
  if (nextQtyInputRef.current) {
      nextQtyInputRef.current.focus();
    }
};

const handleAmountChange = (e, index) => {
  const newRows = [...rows];
  newRows[index].qty = parseFloat(e.target.value) || 0;
  newRows[index].uamount = parseFloat(newRows[index].uamount) || 1;
  const netamount = (newRows[index].qty * newRows[index].uamount).toFixed(2);
  newRows[index].netamount = parseFloat(netamount);
  const remainQty = newRows[index].totqty - newRows[index].qty;
  if (remainQty < 0) {
    Swal.fire("Stock not available");
    newRows[index].remainQty = 0;
    newRows[index].qty = newRows[index].totqty;
    newRows[index].netamount = parseFloat((newRows[index].totqty * newRows[index].uamount).toFixed(2));
  } else {
    newRows[index].remainQty = remainQty;
  }
  setRows(newRows);
};


  const handleAddRow = () => {
    const newRows = [...rows];
    newRows.push({ did: '', id: '', product: '', batch: '', expiry: '', totqty: '', uamount: ''});
    setRows(newRows);
  };

  const inputRefs = useRef([]);
  useEffect(() => {
      inputRefs.current[inputRefs.current.length - 1]?.focus();
  }, [rows.length]);

  const handleDeleteRow = (index) => {
    const newRows = [...rows];
    newRows.splice(index, 1);
    setRows(newRows);
  };

  useEffect(() => {
    let subTotal = 0;
    let newTotal = 0;
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      subTotal += row.netamount;
      newTotal = subTotal;
    }
    setSubTotal(subTotal);
    setTotal(newTotal);
  }, [rows]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setpharmData(prevState => ({ ...prevState, [name]: value }));
  };

const formSubmit = (e) => {
  e.preventDefault();

  const dbType = document.getElementById('dbType').value;

  const totqtyMap = {};
  const tqtyMap = {};

  console.log("ROWS 👉", rows);
  console.log("ITEMS 👉", items);

  rows.forEach(row => {
    const item = items.find(item => item.product.id == row.did);
    const itemTotqty = Number(item?.product?.totqty);
    const returnQty  = Number(row.qty);
    const indentQty  = Number(row.totqty);

    totqtyMap[row.id] = indentQty - returnQty;
    tqtyMap[row.did]  = itemTotqty + returnQty;
  });

  axios.post(`${baseUrl}get_sale_return/`)
    .then(response => {
      const sale_return = response.data.value;

      const _formData = new FormData();
      _formData.append('return_no', sale_return);
      _formData.append('return_type', dbType);
      _formData.append('product', rows.map(r => r.id).join(','));
      _formData.append('qty', rows.map(r => r.qty).join(','));
      _formData.append('netamount', rows.map(r => r.netamount).join(','));
      _formData.append('total', total.toFixed(2));
      _formData.append('mode', dbType);
      _formData.append('status', '1');
      _formData.append('addedby', userName);
      _formData.append('ip_add', ipAddress);
      _formData.append('location', userLocation);

      axios.post(`${baseUrl}pharm-sale-return/`, _formData)
        .then(res => {

          if (res.status === 200 || res.status === 201) {

            // UPDATE INDENT USE
            rows.forEach(row => {
              const pharmData = {
                product: row.did,
                qty: totqtyMap[row.id],
                ip_add: ipAddress,
              };

              axios.put(`${baseUrl}update-indent-use/${row.id}/`, pharmData)
                .then(r => console.log("INDENT UPDATE OK 👉", r.data))
                .catch(err => console.log("INDENT UPDATE ERROR 👉", err.response?.data));
            });

            // UPDATE PHARMACY STOCK
            rows.forEach(row => {
              const pharmData1 = {
                totqty: tqtyMap[row.did],
                ip_add: ipAddress,
              };
              axios.put(`${baseUrl}update-pharm-qty/${row.did}/`, pharmData1)
                .then(r => console.log("PHARM UPDATE OK 👉", r.data))
                .catch(err => console.log("PHARM UPDATE ERROR 👉", err.response?.data));
            });

            Swal.fire({
              title: 'Return Bill Generated.',
              icon: 'success',
              timer: 5000,
              showConfirmButton: false
            });
             setTimeout(() => {
                   window.location.href = '/pharm-invoice-return/' + sale_return + '/';
               }, 3000);

          }
        })
        .catch(error => {

          Swal.fire('Error!', 'Failed. Please try again later.', 'error');
        });
    })
    .catch(error => {

      Swal.fire('Error!', 'Failed to generate unique value.', 'error');
    });
};

  return (
  <section className="container mt-4">
  <form>
    <div className='table-responsive'>
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 60}}>ID</th>
          <th style={{width: 200}}>Drug Name</th>
          <th style={{width: 90}} >Qty</th>
          <th style={{width: 140}}>Batch</th>
          <th style={{width: 130}}>Expiry</th>
          <th style={{width: 90}} >Qty in Stock</th>
          <th style={{width: 110}} >MRP 1s</th>
          <th style={{width: 120}}>Net Amount</th>
          <th style={{width: 90}} >Remain Qty</th>
           <th style={{width: 80}} >Action</th>
        </tr>
      </thead>

      <tbody>
      {rows.map((row, index) => (
        <tr key={index}>
        <td>
        <input
            type="text"
            name="did"
            value={row.did}
            onChange={(e) => handleChange(e, index)}
            style={{width: 60, display: 'none'}}
            tabIndex={-1}
            readOnly
          />
          <input
            type="text"
            name="did"
            className="ms-1 me-2 mt-4"
            value={row.did}
            onChange={(e) => handleChange(e, index)}
            style={{width: 60, display: 'none'}}
            tabIndex={-1}
            readOnly
          />
          <input
            type="text"
            name="id"
            value={row.id}
            onChange={(e) => handleChange(e, index)}
            style={{width: 60}}
            tabIndex={-1}
            readOnly
          />
          </td>
          <td>

        <AutoComplete
          items={items}
          options={items}
          sx={{ width: 200 }}
          componentsProps={{
            paper: {
              sx: {
                width: 800
              }
            }
          }}
          fullWidth
          onKeyDown={e => handleKeyDown(e, index)}
          onChange={(event, val, id) => handleSelect(val, index, id)}
          getOptionLabel={(option) => option.product ? option.product.product : ''}

           renderOption={(props, option) => (
              <Box component="li" {...props}
              fullWidth
              sx={{
              width: 750,
              height: 50,
              borderRadius: 1,
                }}
              >
                {option.product ? `${option.product.product} ID: ${option.product.id} Expy: (${option.product.expiry}) 1s MRP: (${option.product.uamount}) Batch: ${option.product.batch}
                TQty: ${option.qty} ` : ''}
              </Box>

            )}
           renderInput={(params) => (
            <div ref={params.InputProps.ref}>
            <input className="form-control" type="text" {...params.inputProps} fullWidth focused autoFocus
               style={{
                  background: "#F7EEFF",
                  }}
             />
            </div>
           )}
            ref={(el) => inputRefs.current[index] = el}

           />
           </td>
           <td>
          <input
              type="number"
              style={{ width: 90 }}
              className="ms-3 me-1"
              value={row.qty}
              name="qty"
              onChange={(e) => {
                handleChange(e);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
              ref={nextQtyInputRef}
              required
            />
           </td>
           <td>
            <input
              type="text"

              style={{width: 110}}
              name="batch"
              value={row.batch}
              onChange={(e) => handleChange(e, index)}
              tabIndex={-1}
            />
            </td>
           <td>
            <input
              type="text"
              className="ms-2 me-1"
              style={{width: 90}}
              name="expiry"
              value={row.expiry}
              onChange={(e) => handleChange(e, index)}
              tabIndex={-1}
            />
            </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 90}}
              name="totqty"
              value={row.totqty}
              onChange={(e) => handleChange(e, index)}
              tabIndex={-1}
              readOnly
            />
            </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 90}}
              name="uamount"
              value={row.uamount}
              onChange={(e) => {
                handleChange(e);
                handleAmountChange(e, index);
              }}
              tabIndex={-1}
              readOnly
            />
            </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 140}}
              name="netamount"
              value={row.netamount}
              tabIndex={-1}
              readOnly
            />
            </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              name="remainQty"
              style={{width: 80}}
              value={row.remainQty}
              readOnly
              tabIndex={-1}
            />
            </td>
           <td>
             <button className="btn btn-danger" type="button" onClick={() => handleDeleteRow(index)}>Delete</button>
             </td>
        </tr>
      ))}
        </tbody>
        </table>
      <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRow}>Add More</button>
  <div className="row ms-5 mt-5">

  <div className="col-md-6">
  <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
    <div className="form-group">
      <label style={{ fontWeight: 'bold' }}>Subtotal: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input type="number" value={subtotal} readOnly />
      </div>
    </div>
    <div className="form-group mt-3">
      <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input type="number" onChange={handleChange} name="tot" value={total} readOnly />
      </div>
    </div>
  </div>
  </div>
  <div className="col-md-6">
    <div className="form-group">
      <label>Choose Payment Type</label>
      <select name="dbType" id="dbType" >
        <option value="internal">Return</option>
      </select>
    </div>

  </div>
</div>
<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='mb-5' >
          <button type="button"  onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
</div>
    </div>
    </form>
  </section>
  );
};

export default InternalReturn;
